import { useState } from 'react';
import { ModalDefault } from 'components/ModalDefault/ModalDefault';
import styles from './QrImage.module.css';

interface IQrPreviewProps {
  src?: string | null;
  name?: string | null;
}

export const QrPreview = ({ src, name }: IQrPreviewProps) => {
  const [open, setOpen] = useState(false);

  if (!src) {
    return <>{name || '–'}</>;
  }
  return (
    <>
      <span className={styles.cell}>
        <button type='button' className={styles.thumbButton} title={'Открыть QR-код'} onClick={() => setOpen(true)}>
          <img className={styles.thumb} src={src} alt={'QR-код'} />
        </button>
        {name && <span className={styles.name}>{name}</span>}
      </span>
      <ModalDefault title={'QR-код'} active={open} setActive={setOpen}>
        <img className={styles.full} src={src} alt={'QR-код'} />
        {name && <p>Получатель: {name}</p>}
      </ModalDefault>
    </>
  );
};
